import { registerSW } from 'virtual:pwa-register';
import { quietToast } from './ui/toast';

/**
 * Install the service worker.
 *
 * Wirespan is fully self-contained once cached — the grid is generated on
 * device, so an installed copy plays offline indefinitely, including the
 * archive. Updates are applied on the next launch rather than mid-puzzle.
 */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) return;

  registerSW({
    immediate: true,
    onOfflineReady() {
      // Ambient news yields: never stomp a nudge the player just provoked.
      quietToast('Ready to play offline.');
    },
    onRegisterError(error) {
      console.error('Service worker registration failed', error);
    },
  });
}
